















































import { Component, Mixins } from 'vue-property-decorator';
import GlobalMixins from '@/plugins/mixins';
import { Imgs } from 'types/index';
import HomeHeader from './HomeHeader.vue';
import firebase from 'firebase';
import { User } from '@/interface/user';

@Component({
	components: {
		HomeHeader,
	},
})
export default class HomeBanner extends Mixins(GlobalMixins) {
	private imgs: Imgs = {
		loginBanner: require('assets/home/banner.jpg'),
	};

	private loading: boolean = false;

	public async githubLogin() {
		const provider = new firebase.auth.GithubAuthProvider();
		provider.addScope('repo');
		provider.addScope('admin:repo_hook');
		provider.addScope('user');
		provider.addScope('delete_repo');
		provider.addScope('workflow');

		// for GraphQL
		provider.addScope('read:org');
		provider.addScope('read:public_key');
		provider.addScope('read:gpg_key');

		await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
		firebase
			.auth()
			.signInWithPopup(provider)
			.then((result: Record<string, any>) => {
				const user: User = {
					displayName: result.user.displayName,
					photoURL: result.user.photoURL,
					email: result.user.email,
					accessToken: result.credential.accessToken,
					userName: result.additionalUserInfo.username,
				};
				this.$store.commit('setUser', user);
				this.$session.write('userInfo', user);
				this.$assign('/dashboard');
			}).catch((error) => {
				console.error(error);
			});
	}
}
